import { useEffect, useState } from 'react';
import CodeUtil from '../../util/CodeUtil';
import { CODE_GROUP_ID } from '../../constant/Constant';
import { InfoTxt, ModalHeader } from '../../component/ModalRef';

import InputBox from '../../component/InputBox';
import SelectionBox from '../../component/SelectionBox';
import { ToggleButtonUserRegValidStatus } from '../../component/ToggleBottonBox';
import { useDispatch } from 'react-redux';
import { actionEditUserRegValidStatusCd } from '../../module/body/semester/SemesterStudentUniversityModule';
import NullCheckUtil from '../../util/NullCheckUtil';
import CancelButtonBox from '../../component/buttons/CancelButtonBox';
import ConfirmButtonBox from '../../component/buttons/ConfirmButtonBox';
import TelNoInputBox from '../../component/TelNoInputBox';
import SessionStorageUtil from '../../util/SessionStorageUtil';

/* 모달을 닫기 위해서 modalRef를 반드시 전달받아야 함 */
const SemesterStudentUniversityModal = ({ row, modalRef, popupRef, callback }) => {
    const dispatch = useDispatch();
    const [userRegValidStatusCd, setUserRegValidStatusCd] = useState();
    const semesterId = SessionStorageUtil.getCurrentSemesterId();

    useEffect(() => {
        row && setUserRegValidStatusCd(row.userRegValidStatusCd);
    }, []);

    // 취소 버튼
    const handleCancel = () => {
        modalRef.current.close();
    };

    // 확인 버튼
    const handleConfirm = () => {
        if (NullCheckUtil.isEmpty(userRegValidStatusCd)) {
            popupRef.current.openInfo('본교가입검증상태 값을 선택해 주세요.');
        } else {
            dispatch(
                actionEditUserRegValidStatusCd({
                    data: {
                        userId: row.userId,
                        semesterId,
                        userRegValidStatusCd,
                        force: true,
                    },
                    callback: () => {
                        popupRef.current.openInfo('정상 처리 되었습니다.', () => {
                            return function () {
                                callback();
                                modalRef.current.close();
                            };
                        });
                    },
                }),
            );
        }
    };

    // 타이틀 및 안내 메시지 수정
    // 내용 추가
    return (
        <>
            <ModalHeader title='본교 학생 가입검증 수정' modalRef={modalRef} />
            <div className='modal-body'>
                <div className='con-inner SemesterStudentUniversityModal'>
                    <InfoTxt infoTxt='본교 학생의 본인가입을 확인합니다.' />
                    <div>
                        <div className='form-box-row'>
                            <InputBox
                                title='사용자ID'
                                value={row.userId}
                                onChange={(e) => setUserId(e.target.value)}
                                disabled
                            />
                            <InputBox
                                title='이름'
                                value={row.userNm}
                                onChange={(e) => setUserNm(e.target.value)}
                                disabled
                            />
                        </div>
                        <div className='form-box-row'>
                            <InputBox
                                title='이메일'
                                value={row.email}
                                onChange={(e) => setEmail(e.target.value)}
                                disabled
                            />
                            <TelNoInputBox title='연락처' value={row && row.telNo} disabled />
                        </div>
                        <div className='form-box-row'>
                            <SelectionBox
                                title='소속대학'
                                value={row.userUniversityCd}
                                options={CodeUtil.getCodes(CODE_GROUP_ID.USER_UNIVERSITY)}
                                onChange={(e) => setUserUniversityCd(e.target.value)}
                                disabled
                            />
                            <InputBox
                                title='전공(학과)'
                                value={row.majorDeptNm}
                                onChange={(e) => setMajorDeptNm(e.target.value)}
                                disabled
                            />
                        </div>
                        <div className='form-box-row'>
                            <InputBox
                                title='학번'
                                value={row.studentId}
                                onChange={(e) => setStudentId(e.target.value)}
                                disabled
                            />
                        </div>
                        <div className='form-box-row'>
                            {/* <ToggleButtonUserRegValidStatus
                                title={'본교가입검증'}
                                userRegValidStatusCd={userRegValidStatusCd}
                                onChangeUserRegValidStatusCd={setUserRegValidStatusCd}
                            /> */}
                            <SelectionBox
                                title='본교가입검증'
                                value={row.userRegValidStatusCd}
                                useAll={false}
                                options={CodeUtil.getCodes(CODE_GROUP_ID.USER_REG_VALID_STATUS)}
                                onChange={(e) => setUserRegValidStatusCd(e.target.value)}
                            />
                        </div>
                    </div>
                </div>
                <div className='modal-btn-wrap'>
                    <CancelButtonBox title='취소' onClick={(e) => handleCancel()} />
                    <ConfirmButtonBox title='확인' onClick={(e) => handleConfirm()} />
                </div>
            </div>
        </>
    );
};

export default SemesterStudentUniversityModal;
